if (!customElements.get('mg-mobile-sort')) {
  customElements.define('mg-mobile-sort', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const select = this.querySelector('select');
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  });
}
